import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Loader2, ShieldCheck } from 'lucide-react';

/** Second login step: 6-digit code from the authenticator app (or a backup code). */
export default function TwoFactorStep({ onSubmit, onCancel }) {
  const [code, setCode] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const submit = async (e) => {
    e.preventDefault();
    if (!code.trim()) return;
    setBusy(true); setError('');
    try { await onSubmit(code.trim()); }
    catch (err) { setError(err.response?.data?.detail || 'Code incorrect'); setCode(''); }
    setBusy(false);
  };
  return (
    <form onSubmit={submit} className="bg-white border border-slate-200 shadow-sm rounded-2xl p-6 space-y-4" data-testid="twofa-step">
      <div className="flex items-center gap-2">
        <ShieldCheck className="w-5 h-5 text-[#006400]" />
        <p className="text-sm font-semibold text-[#0D2612]">Double authentification</p>
      </div>
      <p className="text-xs text-slate-600">Entrez le code à 6 chiffres affiché dans votre application d'authentification. Téléphone perdu ? Utilisez un de vos codes de secours.</p>
      <Input autoFocus inputMode="numeric" autoComplete="one-time-code" value={code} maxLength={9}
        onChange={e => setCode(e.target.value.toUpperCase())} placeholder="123456"
        className="h-12 text-center text-xl tracking-[0.4em] bg-white border-slate-300" data-testid="twofa-code-input" />
      {error && <p className="text-xs text-red-600">{error}</p>}
      <Button type="submit" disabled={busy || !code.trim()} className="w-full bg-[#006400] text-white hover:bg-[#004D00] font-semibold h-11" data-testid="twofa-submit">
        {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : 'Valider'}
      </Button>
      <button type="button" onClick={onCancel} className="w-full text-[11px] text-slate-500 hover:underline">Retour</button>
    </form>
  );
}
